module.exports = __webpack_public_path__ + "static/media/san-marino.0ffe6242.png";